var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApartmentinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.756 19.41l-9.167-9.166a.834.834 0 00-1.178 0l-9.167 9.167a.834.834 0 00.59 1.422h1.04a.208.208 0 01.21.209v8.125a.833.833 0 00.832.833h4.792a.208.208 0 00.209-.208v-3.959a2.084 2.084 0 014.166 0v3.959a.208.208 0 00.209.208h4.791a.833.833 0 00.834-.833v-8.125a.208.208 0 01.208-.209h1.042a.834.834 0 00.589-1.422zM20 20a2.083 2.083 0 110-4.167A2.083 2.083 0 0120 20z",
    fill: "#0F0449"
  })));
}

export default SvgApartmentinline;